import { A as i } from "./alert-BtYEToNN.js";
import { c as u } from "./config-CR7-T5w_.js";
import { g as o } from "./gsap-wrapper-slU9VysJ.js";
import { t as p } from "./tiny-slider-BlGMK5_4.js";
import { W as r, $ as t } from "./wishlist-D_O2E7UU.js";
const m = () => {
  t(".buy-variant:not(.handled)")
    .addClass("handled")
    .on("click", function (e) {
      e.preventDefault(),
        t.ajax({
          url: u.urlBase + "/cart/add.js",
          type: "POST",
          data: { items: [{ quantity: 1, id: t(this).data("variant") }] },
          dataType: "json",
          success: function (a) {
            a.items && a.items.length > 0
              ? (i.show("Product added to cart", "success"), f())
              : i.show("Product could not be added to cart", "danger");
          },
        });
    });
};
t(document).ready(() => m());
const f = () => {
    t.ajax({
      url: u.urlBase + "/cart.js",
      type: "GET",
      dataType: "json",
      success: function (e) {
        e.item_count &&
          t("#CartCount [data-cart-count]").text(e.item_count) &&
          t("#CartCount")[e.item_count > 0 ? "removeClass" : "addClass"](
            "hide"
          );
      },
    });
  },
  l = () => {
    t(".add-wishlist:not(.handled)")
      .addClass("handled")
      .on("click", function (e) {
        e.preventDefault(),
          r.add(t(this).data("product")),
          i.show("Product added to wishlist", "success");
      });
  };
t(document).ready(function () {
  l(),
    setTimeout(() => l(), 2e3),
    t(".show-wishlist").on("click", function (e) {
      e.preventDefault();
      const a = document.querySelector(".wishlist-container");
      a.innerHTML === "" ? r.render() : (a.innerHTML = "");
    });
});
t(document).ready(function () {
  const e = [6, 19, 26, 34];
  (document.querySelectorAll(".image-gallery") || []).forEach((d, c) => {
    p({
      container: d,
      items: 1,
      slideBy: "page",
      autoplay: !0,
      controls: !1,
      nav: !1,
      autoplayButtonOutput: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !0,
    });
    const n = document.querySelector(".products-list");
    if (n) {
      const s = document.createElement("li");
      s.classList.add("grid__item", "slider", "slider-" + c),
        s.appendChild(d),
        n.insertBefore(s, n.children[e[c]]);
    }
  });
});
t(document).ready(function () {
  o.play("layout"),
    t("body").hasClass("template-index") &&
      (o.play("home"), o.play("productList")),
    t("body").hasClass("template-collection") && o.play("productList");
});
document.addEventListener("DOMContentLoaded", function () {
  window.endlessScroll = new Ajaxinate({
    callback: function (e) {
      setTimeout(() => m(), 1e3);
    },
  });
});
